/**
 * The actions a person can take in an agent session: the `action` argument of
 * `actOnSession`. The backend owns the vocabulary and lists the ones a session accepts
 * right now in `availableActions`; these are the ones this client names itself. A FORM
 * card carries its own `action`, so a form this build has never seen still submits.
 */
export const AGENT_ACTIONS = {
  requestDriverOptions: "request_driver_options",
  regenerateConcepts: "regenerate_concepts",
  selectConcept: "select_concept",
  sendMessage: "send_message",
  submitBrief: "submit_brief",
} as const;
